import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import 'tom-select/dist/js/plugins/dropdown_input'

export default class extends Controller {
  static targets = ["select"]

  connect() {
    const plugins = ['dropdown_input']
    if (this.selectTarget.dataset.clearButton === "true") {
      plugins.push("clear_button")
    }

    this.tomSelect = new TomSelect(this.selectTarget, {
      plugins,
      placeholder: this.selectTarget.dataset.placeholder,
      allowEmptyOption: true,
      closeAfterSelect: true,
      searchable: this.selectTarget.dataset.searchable === "true",
      render: {
        no_results: function(data, escape) {
          return '<div class="no-results">No results found</div>';
        },
        option_create: function(data, escape) {
          return '<div class="create">Add <strong>' + escape(data.input) + '</strong>&hellip;</div>';
        }
      },
      onInitialize: function() {
        const input = this.control_input;

        if (input) {
          input.classList.add('ts-input-element');
        }
      }
    })
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }
}
